module.exports = __webpack_public_path__ + "img/edit.2e30a15f.svg";